export default __webpack_public_path__ + "static/media/ic_payment_white.005e5bc0.svg";